export default __webpack_public_path__ + "img/chat-play.ec8cc9b6.svg";